import React from 'react';
import { practiceInfo } from '../data/mock';
import { Phone, Mail, MapPin, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Membership', href: '#membership' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contact', href: '#contact' },
  ];

  const services = [
    'Annual Wellness Exams',
    'Preventative Care',
    'Hormone Therapy',
    'Chronic Disease Management',
    '24/7 Provider Access',
  ];

  return (
    <footer className="bg-[#1a1a1a] text-[#fffef8]">
      {/* Main footer */}
      <div className="container-custom section-padding-sm">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={practiceInfo.logo}
                alt="Exquisite Concierge Medicine"
                className="h-10 w-auto"
              />
              <div>
                <span className="font-serif text-lg text-[#fffef8]">
                  Exquisite
                </span>
                <span className="block text-xs text-[#8a8a8a] tracking-[0.15em] uppercase">
                  Concierge Medicine
                </span>
              </div>
            </div>
            <p className="text-[#8a8a8a] text-sm leading-relaxed mb-6">
              Personalized healthcare elevated to an art form. Experience medicine 
              as it should be—unhurried, comprehensive, and focused entirely on you.
            </p>
            <div className="space-y-3">
              <a href={`tel:${practiceInfo.phone}`} className="flex items-center gap-3 text-sm text-[#b8b8b8] hover:text-[#c9a962] transition-colors">
                <Phone size={14} />
                <span>{practiceInfo.phone}</span>
              </a>
              <a href={`mailto:${practiceInfo.email}`} className="flex items-center gap-3 text-sm text-[#b8b8b8] hover:text-[#c9a962] transition-colors">
                <Mail size={14} />
                <span>{practiceInfo.email}</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-[#b8b8b8]">
                <MapPin size={14} className="flex-shrink-0 mt-1" />
                <span>{practiceInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#fffef8] font-medium mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-[#8a8a8a] hover:text-[#c9a962] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#fffef8] font-medium mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-sm text-[#8a8a8a]">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Office Hours */}
          <div>
            <h4 className="text-[#fffef8] font-medium mb-6">Office Hours</h4>
            <div className="space-y-3 text-sm text-[#8a8a8a]">
              <div className="flex justify-between">
                <span>Monday - Friday</span>
                <span>By Appointment</span>
              </div>
              <div className="flex justify-between">
                <span>Saturday</span>
                <span>By Appointment</span>
              </div>
              <div className="flex justify-between">
                <span>Sunday</span>
                <span>By Appointment</span>
              </div>
            </div>
            <div className="mt-6 p-4 bg-[#252525]">
              <p className="text-xs text-[#c9a962] mb-1">Members Only</p>
              <p className="text-sm text-[#b8b8b8]">
                Premier & Executive members have 24/7 access to their provider.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#2a2a2a]">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[#6a6a6a]">
              © {new Date().getFullYear()} Exquisite Concierge Medicine. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-xs text-[#6a6a6a]">
              <a href="#" className="hover:text-[#c9a962] transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-[#c9a962] transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-[#c9a962] transition-colors">HIPAA Notice</a>
            </div>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 bg-[#252525] flex items-center justify-center hover:bg-[#c9a962] transition-colors"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* HIPAA Disclaimer */}
      <div className="bg-[#151515]">
        <div className="container-custom py-4">
          <p className="text-xs text-[#5a5a5a] text-center leading-relaxed">
            This website is for informational purposes only and does not constitute medical advice. 
            The information provided should not be used to diagnose or treat any health problems. 
            Always consult with a qualified healthcare provider regarding any medical concerns. 
            This site complies with the Health Insurance Portability and Accountability Act (HIPAA) 
            privacy standards. Your personal health information is protected and will never be shared 
            without your explicit consent.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
